/**
 * @author Irakli Kandelaki
 */

export default (timeoutFunc: number | null): void => {
    if (timeoutFunc === null) return;
    clearTimeout(timeoutFunc);
}
